import React from 'react';
import classNamesBind from "classnames/bind";
import styles from './MyPageGoodsRequestUpdate.module.scss';
import {ViewSelector} from '../../../../shares/viewSelector/ViewSelector';
import {
    GoodsUpdateRequestList,
    GoodsUpdateRequestStatus,
    MutationAllowUpdateGoodsRequestArgs,
    MutationCancelUpdateGoodsRequestArgs
} from "../../../../../graphql/types";
import {useTranslation} from "react-i18next";
import moment from "moment";
import {Pipe} from "../../../../../utils/pipe/pipe";
import {IconButton, Tooltip, withStyles} from "@material-ui/core";
import {DeleteOutlined, Done, SpellcheckOutlined, SupervisorAccount} from "@material-ui/icons";
import {OnChangeValue} from "../../../../Intefaces";
import {CompanyDataMap} from "../../../../../graphql/customScalars";
import {BadgeGoodsUpdateRequestStatus} from "../../../../shares/badgeGoodsUpdateRequestStatus/BadgeGoodsUpdateRequestStatus";
import {BizNoDataTable} from "../../../../shares/bizNoDataTable/BizNoDataTable";
import {BizGoodsIconInTable} from "../../../../shares/bizGoodsIconInTable/BizGoodsIconInTable";
import {navigate} from "hookrouter";
import {BizGoodsModalData} from "../../../../shares/bizGoodsModal/BizGoodsModal";
import {GoodsListResultProcessBar} from "../../list/result/processBar/GoodsListResultProcessBar";

const cx = classNamesBind.bind(styles);

interface Props {
    myCompany: CompanyDataMap,
    goodsUpdateRequestList: GoodsUpdateRequestList,
    onShowGoodsData: OnChangeValue<BizGoodsModalData>,
    onAllowGoodsUpdateRequest: OnChangeValue<MutationAllowUpdateGoodsRequestArgs>,
    onCancelGoodsUpdateRequest: OnChangeValue<MutationCancelUpdateGoodsRequestArgs>,
}

export const MyPageGoodsRequestUpdate = (props: Props) => {
    return (
        <>
            <ViewSelector
                web={<Web {...props}/>}
                mobile={<Mobile {...props}/>}/>
        </>
    )
}

const Web = (props: Props) => {
    const [t] = useTranslation('common');

    const MemoTooltip = withStyles({
        tooltip: {
          fontSize: "14px",
          backgroundColor: "#ffffff",
          border: "dotted 2px",
          borderColor: "red",
          color: "#E77306",
          padding: "15px",
          textAlign: "left"
        }
    })(Tooltip);

    return (
        <>
            <div className={cx('table', 'table-list', 'mb-none')}>
                <div className={cx('header', 'box-created-at')}>{t('mypageGoods.registryAt')}</div>
                <div className={cx('header', 'box-status')}>{t('mypageGoods.status')}</div>
                <div className={cx('header', 'box-goods')}>{t('mypageGoods.goodsNm')}</div>
                <div className={cx('header', 'box-fee')}>{t("mypageGoods.chargedPoint")}</div>
                <div className={cx('header', 'box-func')}>{t("mypageGoods.function")}</div>
            </div>

            {props.goodsUpdateRequestList.total === 0 && <BizNoDataTable/>}

            {props.goodsUpdateRequestList.list.map((value, index) => {
                return (
                    <div key={index} className={cx('table', 'table-list', 'hover')}>
                        <div
                            className={cx('col', 'box-created-at')}>{moment(value.createdAt).format('YY.MM.DD')}</div>
                        <div className={cx('col', 'box-status')}>
                            <BadgeGoodsUpdateRequestStatus
                                status={value.status}/>
                        </div>
                        <div className={cx('box-goods')} onClick={() => {
                            props.onShowGoodsData({
                                goodsDataMap: value.data,
                                categoryId: value.categoryId,
                                companyDataMap: props.myCompany
                            });
                        }}>
                            <BizGoodsIconInTable
                                goodsDataMap={value.data}
                                categoryId={value.categoryId}/>
                        </div>

                        <div className={cx('col', 'box-fee', 'text-right')}>
                            {Pipe.toSeparatorNumber(-value.chargedPoint)} P
                        </div>

                        <div className={cx('col', 'box-func')}>
                            {value.status === GoodsUpdateRequestStatus.Requested &&
                            <>
                                <Tooltip title={t("mypageGoods.ttCancelUpdateGoods") || ""}>
                                    <IconButton onClick={() => {
                                        props.onCancelGoodsUpdateRequest({updateGoodsRequestId: value.id})
                                    }}>
                                        <DeleteOutlined/>
                                    </IconButton>
                                </Tooltip>
                            </>}

                            {value.status === GoodsUpdateRequestStatus.AdminConfirm &&
                            <>
                                <Tooltip title={t("mypageGoods.ttConfirmUpdateGoods") || ""}>
                                    <IconButton onClick={() => {
                                        props.onAllowGoodsUpdateRequest({updateGoodsRequestId: value.id});
                                    }}>
                                        <Done/>
                                    </IconButton>
                                </Tooltip>

                                <Tooltip title={t("mypageGoods.ttCancelUpdateGoods") || ""}>
                                    <IconButton onClick={() => {
                                        props.onCancelGoodsUpdateRequest({updateGoodsRequestId: value.id})
                                    }}>
                                        <DeleteOutlined/>
                                    </IconButton>
                                </Tooltip>
                            </>}

                            {value.status === GoodsUpdateRequestStatus.AdminCancel &&
                            <>

                                <MemoTooltip title={value.memo}>
                                    <IconButton onClick={() => {
                                        navigate(`/mypage/goods/registry/update/${value.id}`)
                                    }}>
                                        <SpellcheckOutlined/>
                                    </IconButton>
                                </MemoTooltip>
                                <Tooltip title={t("mypageGoods.ttCancelUpdateGoods") || ""}>
                                    <IconButton onClick={() => {
                                        props.onCancelGoodsUpdateRequest({updateGoodsRequestId: value.id})
                                    }}>
                                        <DeleteOutlined/>
                                    </IconButton>
                                </Tooltip>
                            </>}

                            {value.status === GoodsUpdateRequestStatus.Done &&
                            <>
                                <Tooltip title={t("mypageGoods.ttConsultant") || ""}>
                                    <IconButton
                                        onClick={() => navigate(`/mypage/goods/bind/${value.goodsId}`)}>
                                        <SupervisorAccount/>
                                    </IconButton>
                                </Tooltip>
                            </>
                            }
                        </div>

                        <div className={cx('box-progress')}>
                            <GoodsListResultProcessBar
                                status={value.status}/>
                        </div>
                    </div>
                )
            })}

        </>
    )
}

const Mobile = (props: Props) => {
    return (
        <><Web {...props}/></>
    )
}
